import { Routes } from '@angular/router';
import { DashboardPageComponent } from '../components/dashboard/dashboard-page.component';
import { PlaceholderComponent } from '../components/placeholder/placeholder.component';
import { RoutesEnum } from '../../utils/enums/routes.enum';

export const childRoutes: Routes = [
  { path: '', redirectTo: RoutesEnum.Dashboard, pathMatch: 'full' },
  { path: RoutesEnum.Dashboard, component: DashboardPageComponent },
  { path: RoutesEnum.Revenue, component: DashboardPageComponent },
  { path: RoutesEnum.CashAndCreditControl, component: DashboardPageComponent },
  { path: RoutesEnum.TeamPerformance, component: DashboardPageComponent },
  { path: RoutesEnum.Clients, component: DashboardPageComponent },
  {
    path: RoutesEnum.Placements,
    loadComponent: () => import('../components/placements/placements.component').then(m => m.PlacementsComponent),
  },
  {
    path: RoutesEnum.Timesheets,
    loadComponent: () => import('../components/timesheets/timesheets.component').then(m => m.TimesheetsComponent),
  },
  {
    path: RoutesEnum.BalanceSheetItemName,
    loadComponent: () => import('../components/balance-sheet-items/balance-sheet-items.component')
      .then(m => m.BalanceSheetItemsComponent),
  },
  { path: RoutesEnum.Sales, component: PlaceholderComponent },
  { path: RoutesEnum.Purchases, component: PlaceholderComponent },
  { path: RoutesEnum.Hr, component: PlaceholderComponent },
  { path: RoutesEnum.Inventory, component: PlaceholderComponent },
  { path: RoutesEnum.Reports, component: PlaceholderComponent },
  {
    path: RoutesEnum.Settings,
    loadChildren: () => import('../components/settings/setting-routing.module').then(m => m.SETTINGS_ROUTES),
  },
  {
    path: RoutesEnum.Profile,
    loadComponent: () => import('../components/profile/profile-page.component').then(m => m.ProfilePageComponent),
  },
];
